$(window).on('load scroll', () => {
	const winScrollTop = $(window).scrollTop();
	revealOnScroll(winScrollTop);
});

function revealOnScroll(winScrollTop) {
	function init($elements) {
		$elements.each(function() {
			const $this = $(this);

			if (winScrollTop + $(window).outerHeight() / 1.1 > $this.offset().top) {
				$this.addClass('in-view');
			}

			if ($(window).outerHeight() > $this.offset().top) {
				$this.addClass('in-view');
			}
		});
	}

	init($('.js-reveal'));
}

